import { cacheExchange, createClient, fetchExchange } from 'urql'
import { authErrorExchange } from './urqlAuthExchange'
import { errorNotifyExchange } from './urqlErrorNotifyExchange'

// @ts-expect-error import.meta.env is provided by Vite at runtime
export const API_URL = import.meta.env?.VITE_API_URL || '/graphql'

export const client = createClient({
  url: API_URL,
  // MobX stores own entity and list state. Keep urql at the document-cache layer
  // so API responses with omitted stale fields still reach those stores.
  exchanges: [cacheExchange, authErrorExchange, errorNotifyExchange, fetchExchange],
  fetchOptions: () => ({
    credentials: 'include' as const, // sends httpOnly cookie automatically
  }),
})
